import React, { useContext, useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebase";

const UserContext = React.createContext();
export const useUser = () => {
  return useContext(UserContext);
};

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, (usr) => {
      if (usr) {
        const docRef = doc(db, "admin", usr.uid);
        getDoc(docRef).then(async (docSnap) => {
          if (!docSnap.exists()) {
            setUser(null);
            return;
          }
          // Optional profile name from users/{uid}; admin gate does not require it.
          try {
            const userRef = doc(db, "users", usr.uid);
            const userDocSnap = await getDoc(userRef);
            const userName = userDocSnap.exists()
              ? userDocSnap.data()?.name
              : null;
            setUser({
              ...usr,
              displayName: userName || usr.email || usr.uid,
            });
          } catch {
            setUser({ ...usr, displayName: usr.email || usr.uid });
          }
        });
      } else setUser(null);
    });
  }, []);

  const login = (email, password) =>
    signInWithEmailAndPassword(auth, email, password);

  const logout = () => signOut(auth);
  return (
    <UserContext.Provider value={{ user, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
export default UserProvider;
